module.exports = __webpack_public_path__ + "img/app store logo_new_transparent.cbb6658d.svg";